/**
 * The link to a paid damage-history report at autoverleden.nl.
 *
 * **This is the only thing on the site that earns anything.** AutoChecken takes a commission on
 * every damage report bought by someone who arrived through this link, and there is no other
 * revenue — no ads, no paid tier that charges, nothing. Treat it accordingly: it is not a
 * decoration to be tidied away, and the details below are not stylistic.
 *
 * Two of them will silently stop the money if they are "cleaned up":
 *
 * - **`site=www.autochecken.com` is the attribution.** It is how autoverleden.nl knows the visitor
 *   came from here. Drop it, rename it, or move it and every click still works, still sells a
 *   report, and pays nothing. Nothing in this codebase can detect that.
 * - **The plate goes in lower case, without separators** — `s038bl`, not `S-038-BL`. That is what
 *   the previous site sent for years, so it is the form the other end is known to accept.
 *
 * The third is on the link itself rather than here: see `DamageHistorySection` for why it must not
 * carry `rel="noreferrer"`.
 */

const AUTOVERLEDEN_ENDPOINT = 'https://www.autoverleden.nl/prive/betaalMethode_volledig.php'

/** The partner id. See the note above: this parameter *is* the commission. */
const AFFILIATE_SITE = 'www.autochecken.com'

/** Where a reader buys the damage history for one vehicle. */
export function damageReportUrl(licensePlateCompact: string): string {
  const query = new URLSearchParams({
    site: AFFILIATE_SITE,
    kenteken: licensePlateCompact.toLowerCase(),
  })

  return `${AUTOVERLEDEN_ENDPOINT}?${query.toString()}`
}

/** The provider, named on screen — a reader is being sent to a third party and should know which. */
export const DAMAGE_REPORT_PROVIDER = 'Autoverleden.nl'

/** The partner's name in the usage log's click counts. A slug, because the API accepts nothing else. */
export const DAMAGE_REPORT_PARTNER = 'autoverleden'

export const DAMAGE_HISTORY_TITLE = 'Heeft deze auto schade gehad?'

/**
 * Note what this does *not* say. "Open data" is accurate and is exactly the wrong thing to tell a
 * visitor, because it advertises that the whole report comes from a free public dataset anyone could
 * query themselves. See the copy rule in `CLAUDE.md`; the phrase is absent from the hero, the meta
 * description and the footer for the same reason.
 */
export const DAMAGE_HISTORY_SUBTITLE = 'De RDW houdt geen schadeverleden bij'
